export enum NewsLocation {
  US = 'US',
  NonUS = 'NonUS',
  All = 'All',
  Private = 'Private',
}
